import { Badge, Dropdown, Menu } from "antd";
import { useEffect, useState } from "react";

const statusColors = {
  COMPLETED: "green",
  CANCELLED: "red",
  NEAR_COMPLETION: "blue",
  ON_HOLD: "orange",
  IN_PROGRESS: "cyan",
  INITIATED: "purple",
  PLANNED: "magenta",
};

const statusLabels = {
  PLANNED: "Planned",
  INITIATED: "Initiated",
  IN_PROGRESS: "In Progress",
  NEAR_COMPLETION: "Near Completion",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  ON_HOLD: "On Hold",
};

const StatusDropDown = ({ handleSelectStatus, initialStatus }) => {
  const statuses = Object.keys(statusLabels).map((status) => ({
    label: statusLabels[status],
    value: status,
  }));

  const [selectedStatus, setSelectedStatus] = useState(initialStatus);

  const handleMenuClick = (e) => {
    setSelectedStatus(e.key);
    handleSelectStatus(e.key);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {statuses.map((status) => (
        <Menu.Item
          key={status.value}
          style={{
            backgroundColor:
              status.value === selectedStatus ? "#f0f0f0" : "transparent",
          }}
        >
          {status.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    setSelectedStatus(initialStatus);
  }, [initialStatus]);

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <Badge
        color={statusColors[selectedStatus]}
        text={statusLabels[selectedStatus]}
      />
    </Dropdown>
  );
};
export default StatusDropDown;
